import React, { useMemo, useState, useEffect } from "react";


import { debounce, servicePick } from "utils";
import { usePrevious } from "hooks";
import BillingIncrement from "components/Filters/BillingIncrement";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";


import { Checkbox, Form, Input, SelectPicker } from "rsuite";

export default (
    {
        filter = {},
        service,
        supplierList,
        destinationList,
        subdestinationList,
        onChangeFilter,
    }
) => {
    const voiceService = service;
    const prevService = usePrevious(service);

    const [currentSupplierList, setCurrentSupplierList] = useState(supplierList);

    useEffect(() => {
        let clear = false;

        if (prevService !== service) {
            clear = true;
            setCurrentSupplierList([]);
        }

        if (!clear) {
            setCurrentSupplierList(supplierList);
        }
    }, [service, supplierList]);

    const supplierFilter = useMemo(() => {
        return <Form.Control
            accepter={SelectPicker}
            data={currentSupplierList}
            name={servicePick(service, "supplier_key", "supplier_id")}
            placeholder="Supplier"
            valueKey={servicePick(service, "supplier_key", "supplier_id")}
            labelKey={servicePick(service, "supplier_name", "name")}
            style={{ width: 224 }}
            menuStyle={{ width: 360 }}
        />
    }, [currentSupplierList]);

    return (
        <Form
            formDefaultValue={filter}
            onChange={debounce((value) => {
                onChangeFilter(value);
            }, 1000)}
        >
            <FlexGrid align="middle">
                <FlexGridItem>
                    {supplierFilter}
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={SelectPicker}
                        data={destinationList}
                        name={"de_key"}
                        placeholder={"Destination"}
                        valueKey="de_key"
                        labelKey="name"
                        style={{ width: 224 }}
                        menuStyle={{ width: 280 }}
                    />
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={SelectPicker}
                        data={subdestinationList}
                        name={"sde_key"}
                        placeholder={"Subdestination"}
                        valueKey="sde_key"
                        labelKey="name"
                        style={{ width: 224 }}
                        menuStyle={{ width: 320 }}
                    />
                </FlexGridItem>
                {voiceService && <FlexGridItem>
                    <BillingIncrement
                        cleanable={true}
                        classPrefix={"rs-form-control"}
                        style={{ verticalAlign: "none" }}
                    />
                </FlexGridItem>}
                <FlexGridItem>
                    <Form.Control
                        accepter={Input}
                        name={"str"}
                        placeholder={"Group name / phone number"}
                        style={{ width: 300 }}
                    />
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={CustomCheckbox}
                        name={"actual_price"}
                    >
                        Show only groups without payout
                    </Form.Control>
                </FlexGridItem>
            </FlexGrid>
        </Form>
    );
};


const CustomCheckbox = ({ children, defaultValue = false, onChange, ...props }) => {
    const [_value, _setValue] = useState(defaultValue);

    return <Checkbox
        value={_value}
        checked={_value}
        onChange={() => {
            _setValue(!_value);
            onChange(!_value);
        }}
        {...props}
    >
        {children}
    </Checkbox>
};